/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BiometricCredentialDTO = {
    attestationStatus?: BiometricCredentialDTO.attestationStatus;
    credentialId?: string;
    deviceModel?: string;
    deviceName?: string;
    enrolledAt?: string;
    lastUsedAt?: string;
    status?: BiometricCredentialDTO.status;
};

export namespace BiometricCredentialDTO {

    export enum attestationStatus {
        NONE = 'NONE',
        RECORDED = 'RECORDED',
        VERIFIED = 'VERIFIED',
        REJECTED = 'REJECTED',
    }

    export enum status {
        ACTIVE = 'ACTIVE',
        SUSPENDED = 'SUSPENDED',
        REVOKED = 'REVOKED',
    }


}
